import Vue from 'vue'

const EditorMethods = {
  name: 'editorMethods',
  props: ['side'],
  created () {
  },
  data () {
    return {
      modifyPlayListItemItem: undefined
    }
  },
  watch: {
  },
  methods: {
    showPlayListItemModify (data) {
      this.modifyRestriction = data.restriction
      this.modifyPlayListItemItem = data.item
      this.modifyPlayListItemVisible = true
    },
    handleDblClick (item) {
      if (item.Medium.type.indexOf('PlayList') > -1) {
        this.loadEditMediumInMediaEditor(item)
      } else {
        this.showPlayListItemModify({ item, restriction: 'PlayProperties' })
      }
    },
    showMediumBasicEditor (item) {
      // if (item.Medium.type.indexOf('PlayList') > -1) return
      this.editedMedium = item.Medium
      this.mediumBasicEditorVisible = true
    },
    loadMediumUsageInMediaEditor (item) {
      this.$emit('loadMediumUsageInMediaEditor', item.Medium)
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', item.Medium.id)
    },
    extractIntoPlaylist () {
      this.extractPlaylistType = 'PlayList'
      this.extractPlayitemsVisible = true
    },
    extractIntoLayout () {
      this.extractPlaylistType = 'PlayListLayout'
      this.extractPlayitemsVisible = true
    },
    broadcastPlaylistChanged () {
      this.$store.dispatch('User/sendBroadcastMessage', {
        Rooms: 'Playlist_changed',
        Data: {
          playlistId: this.playListWithContentSimple.id,
          userId: this.$store.state.User.user.id
        }
      })
    },
    copyTimeRestrictions (item) {
      this.$store.dispatch('Clipboard/setCopiedPlaylistitemDaytimeRestrictions', item.PlayListItem_DaytimeRestrictions)
      this.$store.dispatch('Clipboard/setCopiedPlaylistitemDateRestrictions', item.PlayListItem_DateRestrictions)
    },
    async pasteTimeRestrictions () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await this.pastePlayListItemDaytimeRestrictions(item)
        await this.pastePlayListItemDateRestrictions(item)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async clearTimeRestrictions () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await this.deletePlayListItemDaytimeRestrictions(item)
        await this.deletePlayListItemDateRestrictions(item)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    copyPlayerExceptions (item) {
      this.$store.dispatch('Clipboard/setCopiedPlayerExceptions', item)
    },
    async pastePlayerExceptions () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await Vue.axios.patch(`playlistitem/${item.id}`, this.$store.state.Clipboard.copied_player_exceptions)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async clearPlayerExceptions () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await this.deletePlayerExceptions(item)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async copyPlayProperties (item) {
      this.$store.dispatch('Clipboard/setCopiedPlayProperties', item)
    },
    async pastePlayProperties () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await Vue.axios.patch(`playlistitem/${item.id}`, this.$store.state.Clipboard.copied_play_properties)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async clearPlayProperties () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await this.deletePlayProperties(item)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async deletePlayProperties (item) {
      await Vue.axios.patch(`playlistitem/${item.id}`,
        {
          anchorX: 0,
          anchorY: 0,
          width: 0,
          height: 0,
          objectFit: 'default',
          objectRotation: 0,
          objectPosition: 'center center',
          playDurationMs: 0,
          playOffsetMs: 0,
          onEndBehaviour: 'loop',
          pausePlayOtherContent: 'play'
        }
      )
      this.broadcastPlaylistChanged()
    },
    async copySynchroListener (item) {
      this.$store.dispatch('Clipboard/setCopiedSynchroListener', item)
    },
    async pasteSynchroListener () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        console.log(this.$store.state.Clipboard.copied_synchro_listener)
        await Vue.axios.patch(`playlistitem/${item.id}`, { listenSynchronize: this.$store.state.Clipboard.copied_synchro_listener })
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async clearSynchroListener () {
      for (const item of this.$store.state.Medium.playitems_selected_right) {
        await this.deleteSynchroListener(item)
      }
      await this.loadData()
      this.broadcastPlaylistChanged()
    },
    async deleteSynchroListener (item) {
      await Vue.axios.patch(`playlistitem/${item.id}`,
        {
          listenSynchronize: ''
        }
      )
      this.broadcastPlaylistChanged()
    },
    async pastePlayListItemDaytimeRestrictions (item) {
      for (const element of this.$store.state.Clipboard.copied_playlistitem_daytime_restrictions) {
        element.PlayListItem = item.id
        delete element.id
        delete element.createdAt
        delete element.updatedAt
        const path = 'PlayListItem_DaytimeRestriction'
        await Vue.axios.post(path, element)
      }
      this.broadcastPlaylistChanged()
    },
    async pastePlayListItemDateRestrictions (item) {
      for (const element of this.$store.state.Clipboard.copied_playlistitem_date_restrictions) {
        element.PlayListItem = item.id
        delete element.id
        delete element.createdAt
        delete element.updatedAt
        const path = 'PlayListItem_DateRestriction'
        await Vue.axios.post(path, element)
      }
      this.broadcastPlaylistChanged()
    },
    async deletePlayListItemDaytimeRestrictions (item) {
      for (const element of item.PlayListItem_DaytimeRestrictions) {
        await Vue.axios.delete(`PlayListItem_DaytimeRestriction/${element.id}`)
      }
      this.broadcastPlaylistChanged()
    },
    async deletePlayerExceptions (item) {
      await Vue.axios.patch(`playlistitem/${item.id}`, { playOnlyInMedia: '[]', playForbiddenInMedia: '[]' })
      this.broadcastPlaylistChanged()
    },
    async deletePlayListItemDateRestrictions (item) {
      for (const element of item.PlayListItem_DateRestrictions) {
        await Vue.axios.delete(`PlayListItem_DateRestriction/${element.id}`)
      }
      this.broadcastPlaylistChanged()
    },
    loadEditMediumInMediaEditor (item) {
      this.$emit('loadEditMediumInMediaEditor', item.Medium)
      this.$store.dispatch('Medium/addMediumIdToBreadcrumbs', item.Medium.id)
    }
  },
  computed: {
  }
}

export default EditorMethods



// WEBPACK FOOTER //
// ./src/components/Medium/EditorMethods.mixin.js